export const AppState = Object.freeze({
  CLOSED: 'CLOSED',
  DISPERSED: 'DISPERSED',
  PHOTO_FOCUS: 'PHOTO_FOCUS'
});

export const Seasons = Object.freeze({
  SPRING: 'SPRING',
  SUMMER: 'SUMMER',
  AUTUMN: 'AUTUMN',
  WINTER: 'WINTER'
});

export const InputEventType = Object.freeze({
  GO_CLOSED: 'GO_CLOSED',
  GO_DISPERSED: 'GO_DISPERSED',
  ENTER_PHOTO_FOCUS: 'ENTER_PHOTO_FOCUS',
  EXIT_PHOTO_FOCUS: 'EXIT_PHOTO_FOCUS'
});

export const ValidationErrorCode = Object.freeze({
  EMPTY_SELECTION: 'EMPTY_SELECTION',
  TOO_MANY_FILES: 'TOO_MANY_FILES',
  FILE_TOO_LARGE: 'FILE_TOO_LARGE',
  INVALID_TYPE: 'INVALID_TYPE'
});

export const UploadLimits = Object.freeze({
  MAX_FILES: 40,
  MAX_FILE_BYTES: 2 * 1024 * 1024
});

export const FpsTarget = Object.freeze({
  IDEAL: 60,
  WARNING: 45
});
